/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_3_TextInputs */

const da_forside_quote_3_text = /** @type {(inputs: Forside_Quote_3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleverne fik feedback på hver eneste opgave dagen efter prøven. Det har jeg aldrig nået før, og det gjorde gennemgangen i klassen langt bedre.`)
};

/** @type {(inputs: Forside_Quote_3_TextInputs) => LocalizedString} */
const en_forside_quote_3_text = da_forside_quote_3_text;

/**

* @param {Forside_Quote_3_TextInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_3_text = /** @type {((inputs?: Forside_Quote_3_TextInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_3_TextInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_3_text(inputs)
	return /** @type {LocalizedString} */ ("Eleverne fik feedback på hver eneste opgave dagen efter prøven. Det har jeg aldrig nået før, og det gjorde gennemgangen i klassen langt bedre.")
});